export default __webpack_public_path__ + "static/media/DarkBlue0000.0bea1700.png";